import { Form, Modal } from 'antd'
import Button from 'components/Button'
import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import * as isLeapYear from 'dayjs/plugin/isLeapYear' // import plugin
import localeData from 'dayjs/plugin/localeData'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import weekYear from 'dayjs/plugin/weekYear'
import weekday from 'dayjs/plugin/weekday'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import styled from 'styled-components'
import ErrorMessage from 'utils/ErrorMessage'
import { systemConfig } from 'utils/config.js'
import SubmitCloseIcon from '../../../components/icons/SubmitCloseIcon'
import {
  dateConversion,
  getSpecialisationKeyFormat,
  isReturnBoolean,
  timeString,
} from '../../../utils/rolecreationHelpers'
import Header from '../NewJobRole/Header/index'
import CompanyDetails from './CompanyDetails'
import RolesForm from './RolesForm'
import {
  autoJDFillStepNum,
  convertEligibilityData,
  eligibilityCriteriaStepNum,
  formattingDataFromPayloadToQualification,
  hasChanged,
  jobDetailsStepNum,
  previewStepNum,
} from './RolesForm/Partials/EligibiltyCriteria/CommonFunctions'
import { MainWrapper, Wrapper } from './RolesForm/style'
import { permittedEventCruds } from 'utils/permissionsValidation'

dayjs.extend(customParseFormat)
dayjs.extend(advancedFormat)
dayjs.extend(weekday)
dayjs.extend(localeData)
dayjs.extend(weekOfYear)
dayjs.extend(weekYear)

const Modals = styled(Modal)`
  .ant-modal-content {
    border-radius: 10px;
    height: 25em;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50em;
  }
`
const NewJobRole = ({
  getListOfCountries,
  countryList = [],
  getListOfStates,
  getListOfCities,
  addNewCompany,
  getListOfCompanies,
  getMasterSearchApi,
  getRolesListData,
  rolesList,
  companyList,
  addNewRole,
  roleData,
  updateNewRole,
  getSpecialisationList,
  specialisationList,
  getCandidateMetrics,
  getRoleDetails,
  getJdDetails,
  instituteCampusId,
  getEligibilityCriteriaQualification,
  getDegreeData,
  degreeList,
  getJobRolePreview,
  searchCities,
  deleteJobRole,
  getEligibilityCriteria,
  permissions,
  getNotificationCatalogues,
  sendNotificationBulkEmail,
  getCities,
  revertInEligibleStudent,
  getInEligibleCandidates,
}) => {
  const dateFormat = 'DD/MM/YYYY'
  const [jdFile, setJdFile] = useState([])
  const [jdData, setJdData] = useState({})
  const [parseLoading, setParseLoading] = useState(false)
  const [loading, setLoading] = useState(true)
  const [stepIcon, setStepIcon] = useState(true)
  const params = useParams()
  const [searchParams] = useSearchParams()
  const [initialResponse, setInitialResponse] = useState({})
  const [publishButtonDisable, setPublishButtonDisable] = useState(true)
  const [previewData, setPreviewData] = useState({})
  const [labelName, setLabelName] = useState('CTC & Job Location')
  const [roleForm] = Form.useForm()
  const [key, setKey] = useState(0)
  const [scoreType, setScoreType] = useState('Average')
  dayjs.extend(isLeapYear) // use plugin
  dayjs.locale('zh-cn') // use locale
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const [isEditModal, setIsEditModal] = useState({
    open: false,
    loading: false,
  })
  const [candidateMetrics, setCandidateMetrics] = useState({})

  const [confirmLoading, setConfirmLoading] = useState(false)
  const modalText = 'Role floated successfully'
  const [currentStep, setCurrentStep] = useState(0)
  const [checkAllCompleted, setCheckAllCompleted] = useState(false)
  const [save, setSave] = useState(false)
  const [triggerBack, setTriggerBack] = useState(false)
  const [deleteRole, setDeleteRole] = useState(false)
  const [skillSearch, setSkillSearch] = useState('')
  const [saveCorporate, setSaveCorporate] = useState(false)
  const [addCompanyDrawer, setAddCompanyDrawer] = useState(false)
  const anyWhere = false
  const [id, setId] = useState('')
  const [load, setLoad] = useState('')
  const [jobRolePreviewData, setJobRolePreviewData] = useState('')
  const [degreeListData, setDegreeListData] = useState([])
  const [listOfMandatorySkills, setListOfMandatorySkills] = useState([])
  const [listOfSkills, setListOfSkills] = useState([])
  const [listOfAddedSkills, setListOfAddedSkills] = useState([])
  const [mandatorySkillCount, setMandatorySkillCount] = useState(0)
  const [draft, setDraft] = useState(false)
  const [editData, setEditData] = useState({})
  const [jobDetailsForm, setJobDetailsForm] = useState({})
  const [qualificationError, setQualificationError] = useState(false)
  const [mandatoryTypeError, setMandatoryTypeError] = useState(false)
  const [selectedType, setSelectedType] = useState([
    { field: '', key: 0, value: '' },
  ])
  const [showRoleDrawer, setShowRoleDrawer] = useState(false)
  const [publishCheck, setPublishCheck] = useState(false)
  const [lengthError, setLengthError] = useState('')
  const [isEdit, setIsEdit] = useState(false)
  const [buttonLoading, setButtonLoading] = useState(false)
  const [jobRoleCreationTemplate, setJobRoleCreationTemplate] = useState(null)

  const permittedEvents = permittedEventCruds(permissions, 'ROLES')
  const onJobRoleCreation =
    permittedEvents?.find(item => item.events?.eventName === 'VIEW')?.events ||
    ''

  const dispatch = useDispatch()
  const [selectedSkills, setSelectedSkills] = useState([])
  const [mandatorySkillsIds, setMandatorySkillsIds] = useState([])
  const [skillsManuallyModified, setSkillsManuallyModified] = useState(false)

  useEffect(() => {
    ;(async () => {
      if (onJobRoleCreation?.id) {
        let response = await getNotificationCatalogues(onJobRoleCreation?.id)
        const filteredArray = response?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName ===
              'institute_jobrole_creation_email' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'E-Mail'
        )
        if (filteredArray?.length > 0) {
          setJobRoleCreationTemplate(filteredArray[0].eventNotificationTemplate)
        }
      }
    })()

    return () => {}
  }, [onJobRoleCreation])

  const [step, setStep] = useState(0)
  const defaultRoleFormData = {
    jobDetails: {
      jobTitle: '',
      functionId: '',
      function: '',
      jobFunction: '',
      jobTypeLevel: [],
      publishTo: 'ALL',
      jobType: 'FULL_TIME',
      hiringTimeline: '',
      employmentType: 'ONROLL',
      internshipStartDate: '',
      internshipEndDate: '',
      jobDescription: '',
      minVacancies: '',
      maxVacancies: '',
      startDate: moment(
        dateConversion({
          date: new Date().toISOString()?.split('T')[0],
          convertTo: 'DD/MM/YYYY',
        }),
        dateFormat
      ),
      endDate: '',
      jobRoleDocs: [],
      jobRolesUrl: '',
      otherLinks: [{ link: '' }],
      companyWebsite: '',
      companyName: '',
      companyDescription: '',
      firstMonth: 0,
      firstYear: 0,
      secondMonth: 0,
      secondYear: 0,
      jobTypeLevels: '',
      durationErr: '',
      sector: '',
      sectorId: '',
    },
    ctc: {
      period: 'ANNUALLY',
      min: null,
      max: null,
      isRange: false,
      isBond: false,
      bondType: '',
      additionalBenefits: '',
      ctcType: '',
      isNoStipend: true,
      isAdditional: false,
      variableAmount:null
    },
    jobLocation: {
      citiesIds: [],
      cities: [],
      isRemoteAllowed: false,
      remotCities: [],
      remotCitiesIds: [],
      isHybridAllowed: false,
      isAnyWhere: anyWhere,
      hybridType: 'MONTHLY',
      hybridValue: '',
    },
    degrees: {
      degreesData: [],
      specialisations: [],
    },
    mandatorySkills: {
      primary: { type: '', skills: [] },
      mandatory: [],
      mandatoryCount: 0,
      otherSkills: [{ type: '', skills: [] }],
    },
    optionalSkills: [],
    yearOfPassing: [],
    yearOfExperience: [],
    scores: {
      avg: 0,
      tenth: 0,
      twelfth: 0,
      UG: 0,
      PG: 0,
      UGDiploma: 0,
    },
    isArrearsAllowed: false,
    arrearCount: {
      condition: 'ET',
      count: 10,
    },
    isHistoryArrears: false,
    historyArrearCount: {
      condition: 'ET',
      count: 0,
    },
    interviewWorkFlow: {
      rounds: [],
    },
    roleFlotedTo: [],
    qualityCriteria: [
      {
        type: [],
        allSelect: false,
        search: '',
        data: [],
        toSearch: 'ALL',
        selected: {
          UG: { isAllDegree: false, data: [] },
          PG: { isAllDegree: false, data: [] },
          DIPLOMA: { isAllDegree: false, data: [] },
        },
        totalTypes: [],
      },
    ],
    jdUrl: [],
    jdDetails: {},
    priorityDegree: '',
    roleStatus: '',
  }
  const [roleFormData, setRoleFormData] = useState(defaultRoleFormData)
  
  // Debug: Track workStyle changes
  useEffect(() => {
    console.log('roleFormData.jobDetails.workStyle changed to:', roleFormData?.jobDetails?.workStyle);
    console.log('Full jobDetails:', roleFormData?.jobDetails);
  }, [roleFormData?.jobDetails?.workStyle])
  const [stepStatus, setStepStatus] = useState({
    jd: false,
    job: false,
    ctc: false,
    qualification: false,
  })
  const [criteriaTypes, setCriteriaTypes] = useState([])
  const handleAddNewCompany = value => {
    setAddCompanyDrawer(value)
  }

  const mandatorySkillsAPI = async (skills, search = '') => {
    console.log('=== MANDATORY SKILLS API CALLED ===')
    console.log('Skills param:', skills)
    console.log('Search param:', search)
    
    let payLoad = systemConfig.skills
    payLoad.q = search
    let data = await getMasterSearchApi('skills', payLoad)
    console.log('API response data:', data)
    const matchedSkills = []
    // 1. Always map all API data for the skills list
    data = data.map(item => {
      if (skills?.length) {
        let selected
        // Find if this skill is in selectedSkills
        if (Array.isArray(skills)) {
          selected = skills?.find(sel => sel?.id === item?.id)
          if (selected) {
            matchedSkills.push({
              isMandatory: selected?.isMandatory,
              skillId: item?.id,
              skillName: item?.name,
              id: item?.id,
            })
          }
        }

        return {
          isMandatory: selected
            ? selected.mandatory
            : mandatorySkillsIds?.includes(item?.id)
            ? true
            : false,
          skillId: item?.id,
          skillName: item?.name,
          id: item?.id,
        }
      } else {
        return {
          isMandatory: mandatorySkillsIds?.includes(item?.id) ? true : false,
          skillId: item?.id,
          skillName: item?.name,
          id: item?.id,
        }
      }
    })

    if (matchedSkills?.length) {
      setSelectedSkills(matchedSkills)
    }
    // }

    if (data.length === 0 && search) {
      data.push({
        isMandatory: false,
        skillId: search,
        skillName: search,
        id: search,
        isNew: true,
      })
    }
    console.log('Setting listOfSkills with data:', data)
    setListOfSkills(data)
    console.log('listOfSkills updated, length:', data?.length)
    console.log('=======================================')
  }
  const handleButtonChanges = () => {
    setButtonLoading(true)
  }

  const fetchRoleData = async ({ roleId, mode, jdDetail, currentIndex }) => {
    setConfirmLoading(true)
    try {
      let response
      if (roleId) {
        response = await getRoleDetails(roleId)
      }

      if (response?.message == 'Success' || jdDetail?.message == 'Success') {
        let singleRoleData = response?.data || jdDetail?.data

        setEditData(response?.data)
        setStep(singleRoleData?.currentState)
        console.log('=== ATTACHMENT DEBUG ===');
        console.log('Original jobRoleDocs:', singleRoleData?.jobRoleDocs);
        
        const fileTypeArr = singleRoleData?.jobRoleDocs
          ?.filter(item => {
            // Filter out empty/invalid attachments
            const isValid = item.fileName && item.fileUrl && item.fileName.trim() !== '' && item.fileUrl.trim() !== ''
            console.log('Attachment validation:', { item, isValid });
            return isValid
          })
          ?.map(item => {
            return {
              name: item.fileName,
              type: item.fileType || '',
              url: item.fileUrl,
              size: item?.fileSize || '',
            }
          }) || []
          
        console.log('Filtered fileTypeArr:', fileTypeArr);
        const otherLinksArr = singleRoleData?.company?.otherLinks?.map(item => {
          return {
            link: item,
          }
        })
        if (
          singleRoleData?.jobCategory == 'INTERNSHIP' ||
          singleRoleData?.jobCategory == 'APPRENTICESHIP'
        ) {
          setLabelName('Stipend & Job Location')
        }
        setKey(key + 1)

        let initialValue = {
          jobDetails: {
            otherLinks:
              otherLinksArr?.length > 0 ? otherLinksArr : [{ link: '' }],
            companyName: singleRoleData.company.companyName,
            jobTitle: singleRoleData?.tittle,
            jobFunction: singleRoleData?.function,
            functionId: singleRoleData?.functionId,
            companyId: singleRoleData?.companyId,
            companyDescription: singleRoleData?.company?.description,
            sector: singleRoleData?.company?.sector,
            sectorId: singleRoleData?.company?.sectorId,
            function: singleRoleData?.function,
            publishTo: singleRoleData?.publishTo,
            jobTypeLevels: singleRoleData?.jobTypeLevels
              ? singleRoleData?.jobTypeLevels[0]
              : [],
            employmentType: singleRoleData?.employmentType,
            hiringTimeline: singleRoleData?.jobDependency,
            description: singleRoleData?.description,
            internshipDuration: singleRoleData?.internshipDuration,
            internshipStartDate: dateConversion({
              date: singleRoleData?.internshipStartDate?.split('T')[0],
              convertTo: 'DD/MM/YYYY',
            }),
            internshipEndDate: dateConversion({
              date: singleRoleData?.internshipEndDate?.split('T')[0],
              convertTo: 'DD/MM/YYYY',
            }),
            jobCategory: singleRoleData?.jobCategory,
            jobType: singleRoleData?.jobType,
            workStyle: singleRoleData?.workStyle,
            externalLink: singleRoleData?.externalLink,
            companyWebsite: singleRoleData.company.website,
            jobRoleDocs: fileTypeArr,
            minVacancies: singleRoleData?.minVacancies,
            maxVacancies: singleRoleData?.maxVacancies,
            startDate: singleRoleData?.startDate
              ? dayjs(
                  dateConversion({
                    date: singleRoleData?.startDate?.split('T')[0],
                    convertTo: 'DD/MM/YYYY',
                  }),
                  'DD/MM/YYYY'
                )
              : moment(
                  dateConversion({
                    date: new Date().toISOString().split('T')[0],
                    convertTo: 'DD/MM/YYYY',
                  }),
                  'DD/MM/YYYY'
                ),
            endDate: singleRoleData?.endDate
              ? dayjs(
                  dateConversion({
                    date: singleRoleData?.endDate?.split('T')[0],
                    convertTo: 'DD/MM/YYYY',
                  }),
                  'DD/MM/YYYY'
                )
              : '',
            endTime: dayjs(timeString(singleRoleData?.endDate), 'HH:mm'),
          },
          ctc: {
            period: singleRoleData?.CTCPeriod,
            additionalBenefits: singleRoleData?.additionalBenefits,
            bondType: singleRoleData?.bondType,
            isBond: singleRoleData?.isBond,
            ctcType: singleRoleData?.ctcType,
            isNoStipend: singleRoleData?.stipend,
            min: singleRoleData?.minCompensation,
            max: singleRoleData?.maxCompensation,
            variableAmount:singleRoleData?.variableAmount,
            isRange:
              singleRoleData?.minCompensation && singleRoleData?.maxCompensation
                ? singleRoleData?.maxCompensation !=
                  singleRoleData?.minCompensation
                : false,
          },

          jobLocation: {
            cities: singleRoleData?.cities?.map(item => ({
              label: item?.name ?? item?.city_name ?? item?.state_name,
              value: item?.id ?? item?.city_id ?? item?.state_id,
              payload: item,
            })),
            citiesIds: singleRoleData?.cities?.map(item =>
              item?.id ? item?.id : item?.city_id ?? item?.state_id
            ),
            isAnyWhere: singleRoleData?.isAnyWhere,
          },
          degrees: {
            degreesData: singleRoleData?.degreeStreamMapIds,
            specialisations: singleRoleData?.specialisations?.map(item =>
              getSpecialisationKeyFormat({
                degreeStreamMapId: item?.degreeStreamMapId,
                specializationId: item?.specialisationsId,
              })
            ),
          },
          eligibility: {
            qualityCriteria: formattingDataFromPayloadToQualification(
              singleRoleData?.eligibilityCriteria,
              criteriaTypes
            ),
            degree: singleRoleData?.degreeStreamMapIds,
            specialisations: singleRoleData?.specialisations?.map(
              item => item.degreeStreamMapId
            ),
          },
          specialisations: singleRoleData?.specialisations,
          jobRoleSkills: singleRoleData?.jobRoleSkills || [],
          yearOfPassing:
            singleRoleData?.yearOfPassing?.[0] != 0
              ? singleRoleData?.yearOfPassing
              : [],

          scores: {
            avg: singleRoleData?.avgScore ? singleRoleData?.avgScore : 0,
            tenth: singleRoleData?.tenthScore,
            twelfth: singleRoleData?.twelfthScore,
            UG: singleRoleData?.UGScore,
            PG: singleRoleData?.PGScore,
            UGDiploma: singleRoleData?.UGDiplomaScore,
          },
          isArrearsAllowed: singleRoleData?.isArrearsAllowed,
          arrearCount: {
            condition: singleRoleData?.arrearCondition,
            count: singleRoleData?.arrearCount,
          },
          isHistoryArrears: singleRoleData?.isHistoryArrears,
          historyArrearCount: {
            condition: singleRoleData?.historyCondition,
            count: singleRoleData?.historyArrearCount,
          },
          interviewWorkFlow: {
            rounds: singleRoleData?.interviewWorkFlow?.rounds,
          },

          qualityCriteria: formattingDataFromPayloadToQualification(
            singleRoleData?.eligibilityCriteria,
            criteriaTypes
          ),
          roleFlotedTo:
            singleRoleData?.roleFlotedTo?.map(item => item.id) ?? [],
          status: singleRoleData?.status,
          jdUrl: singleRoleData?.jdUrl,
          jdDetails: singleRoleData?.jdDetails,
          priorityDegree: singleRoleData?.priorityDegree,
          republishedDate: singleRoleData?.republishedDate,
        }

        if (singleRoleData?.jdUrl) {
          setJdFile(singleRoleData?.jdUrl)
          roleFormData.jdUrl = singleRoleData?.jdUrl || jdFile
        }
        if (singleRoleData?.jdDetails) {
          setJobDetailsForm(singleRoleData?.jdDetails)
          setJdData(singleRoleData?.jdDetails)
          roleFormData.jdDetails = singleRoleData?.jdDetails
          
          const isDuplicatedRole = !!singleRoleData?.duplicatedJobId
          
          if (!isDuplicatedRole) {
            console.log('=== EXISTING JD SKILLS EXTRACTION ===')
            console.log('Existing JD Details:', singleRoleData?.jdDetails)
            
            const existingCompulsorySkills = singleRoleData?.jdDetails?.Compulsory_Skills || []
            const existingSecondarySkills = singleRoleData?.jdDetails?.Secondary_Skills || []
            const existingOptionalSkills = singleRoleData?.jdDetails?.Optional_Skills || []
            
            console.log('Existing Compulsory Skills:', existingCompulsorySkills)
            console.log('Existing Secondary Skills:', existingSecondarySkills)
            console.log('Existing Optional Skills:', existingOptionalSkills)
            
            // Store JD skills for later mapping when skills list is available
            if (existingCompulsorySkills.length > 0 || existingSecondarySkills.length > 0) {
              console.log('Storing JD skills for mapping when skills list is available...')
              
              // Store the JD skills in localStorage for later processing
              const jdSkillsData = {
                compulsorySkills: existingCompulsorySkills,
                secondarySkills: existingSecondarySkills,
                optionalSkills: existingOptionalSkills,
                timestamp: Date.now()
              }
              localStorage.setItem('pendingJdSkills', JSON.stringify(jdSkillsData))
              console.log('JD skills stored for later mapping:', jdSkillsData)
            }
            console.log('=====================================')
          } else {
            console.log('=== DUPLICATED ROLE DETECTED ===')
          }
        }

        if (singleRoleData?.gigsDuration?.length > 0) {
          initialValue.jobDetails.durationFirstYear =
            singleRoleData?.gigsDuration?.[0]?.toString()?.[0] ?? 0
          initialValue.jobDetails.durationFirstMonth =
            singleRoleData?.gigsDuration?.[0]?.toString()?.[2] ?? 0
          initialValue.jobDetails.durationSecondYear =
            singleRoleData?.gigsDuration?.[1]?.toString()?.[0] ?? 0
          initialValue.jobDetails.durationSecondMonth =
            singleRoleData?.gigsDuration?.[1]?.toString()?.[2] ?? 0
        }
        if (singleRoleData?.yearOfExperience?.length > 1) {
          let min = String(singleRoleData?.yearOfExperience?.[0])?.split('.')
          if (min?.length) {
            initialValue.jobDetails.firstYear = min?.[0] ?? 0
            initialValue.jobDetails.firstMonth = min?.[1] ?? 0
          }

          if (singleRoleData?.yearOfExperience?.length > 1) {
            let min = String(singleRoleData?.yearOfExperience?.[0])?.split('.')
            let max = String(singleRoleData?.yearOfExperience?.[1])?.split('.')
            if (min?.length) {
              initialValue.jobDetails.firstYear = min?.[0] ?? 0
              initialValue.jobDetails.firstMonth = min?.[1] ?? 0
            }
            if (max?.length) {
              initialValue.jobDetails.secondYear = max?.[0] ?? 0
              initialValue.jobDetails.secondMonth = max?.[1] ?? 0
            }
          }
        }

        // Only reload skills from backend if they haven't been manually modified
        console.log('=== SKILLS LOADING DEBUG ===')
        console.log('Skills manually modified flag:', skillsManuallyModified)
        console.log('Backend skills:', singleRoleData?.jobRoleSkills?.map(skill => skill.id))
        console.log('Current form skills:', roleFormData?.mandatorySkills?.primary?.skills)
        
        if (!skillsManuallyModified) {
          console.log('Skills not manually modified, loading from backend:', singleRoleData?.jobRoleSkills)
          setSelectedSkills(singleRoleData?.jobRoleSkills || [])
          mandatorySkillsAPI(singleRoleData?.jobRoleSkills, '')
        } else {
          console.log('Skills manually modified, preserving current skills - NOT reloading from backend')
        }
        
        // Reset the flag for new roles (when there's no existing role data)
        if (!params?.roleId && !singleRoleData?.id) {
          setSkillsManuallyModified(false)
          console.log('New role detected, resetting skills modification flag')
        }
        const checkRoleStatus =
          singleRoleData?.jobRoleInstituteMap[0]?.roleStatus
        console.log('=== DEBUGGING JOBTYPE INITIALIZATION ===');
        console.log('singleRoleData.jobType:', singleRoleData?.jobType);
        console.log('singleRoleData.jobCategory:', singleRoleData?.jobCategory);
        console.log('initialValue.jobDetails.jobType:', initialValue?.jobDetails?.jobType);
        console.log('initialValue.jobDetails.jobCategory:', initialValue?.jobDetails?.jobCategory);
        console.log('Full initialValue.jobDetails:', initialValue?.jobDetails);
        
        // Preserve locally changed endTime if it exists
        if (roleFormData?.jobDetails?.endTime) {
          const endTimeValue = roleFormData.jobDetails.endTime;
          if (typeof endTimeValue === 'string') {
            initialValue.jobDetails.endTime = dayjs(endTimeValue, 'HH:mm');
          } else if (endTimeValue && typeof endTimeValue === 'object' && endTimeValue.format) {
            initialValue.jobDetails.endTime = endTimeValue;
          } else {
            initialValue.jobDetails.endTime = dayjs(endTimeValue, 'HH:mm');
          }
        }
        
        setRoleFormData(prevData => ({
          ...prevData,
          ...initialValue,
          scores: initialValue?.scores,
          roleStatus: checkRoleStatus,
        }))
        
        console.log('Setting form fields with initialValue');
        roleForm.setFieldsValue({
          ...initialValue,
        })
        
        // Force set the jobType and jobCategory fields specifically
        setTimeout(() => {
          console.log('Force setting jobType field to:', initialValue?.jobDetails?.jobType);
          console.log('Force setting jobCategory field to:', initialValue?.jobDetails?.jobCategory);
          roleForm.setFieldsValue({
            jobDetails: {
              ...roleForm.getFieldsValue().jobDetails,
              jobType: initialValue?.jobDetails?.jobType || 'FULL_TIME',
              jobCategory: initialValue?.jobDetails?.jobCategory || ''
            }
          });
        }, 100);

        if (singleRoleData?.avgScore) {
          setScoreType('Average')
        } else if (
          roleFormData?.scores?.tenth == '0' &&
          roleFormData?.scores?.twelfth == '0' &&
          roleFormData?.scores?.avg == 0
        ) {
          setScoreType('Average')
        } else {
          setScoreType('Custom')
        }

        if (mode === 'initial') {
          if (!triggerBack) {
            if (checkRoleStatus == 'DRAFT') {
              setCurrentStep(currentIndex ?? singleRoleData?.currentState)
              setStepIcon(false)
            } else {
              if (singleRoleData?.republishedDate) {
                setCheckAllCompleted(true)
                setCurrentStep(jobDetailsStepNum)
              } else {
                setCurrentStep(
                  currentIndex ?? singleRoleData?.currentState ?? 0
                )
              }
            }
            setInitialResponse(structuredClone(singleRoleData))
          }
        }
        if (singleRoleData?.currentState >= previewStepNum) {
          const response = await getJobRolePreview(roleId)
          setJobRolePreviewData(response?.data?.data)
        }
        setPreviewData(singleRoleData)
      }
    } catch (err) {
      //
    } finally {
      setTimeout(() => {
        setConfirmLoading(false)
        setTriggerBack(false)
      }, 1500)
    }
  }
  useEffect(() => {
    if (params) {
      let path = params?.['*']
      if (path?.includes('editRole') && params?.roleId) {
        setId(params.roleId)
        fetchRoleData({ roleId: params.roleId, mode: 'initial' })
      } else {
        setLoading(false)
      }
    }
  }, [params.roleId, criteriaTypes])

  useEffect(() => {
    console.log('=== JD DATA EFFECT TRIGGERED ===')
    console.log('jdData changed:', jdData)
    
    const storedJdValue = localStorage.getItem('jdDetails')
    const storedJdFile = localStorage.getItem('jdFile')
    
    console.log('localStorage jdDetails:', storedJdValue)
    console.log('localStorage jdFile:', storedJdFile)
    
    if (storedJdValue) {
      const parsedJdValue = JSON.parse(storedJdValue) // Parse the JSON string

      console.log('=== JD SKILLS MAPPING DEBUG ===')
      console.log('Parsed JD Value:', parsedJdValue)
      console.log('JD Skills:', parsedJdValue?.skills)
      console.log('JD Mandatory Skills:', parsedJdValue?.mandatorySkills)
      console.log('JD Optional Skills:', parsedJdValue?.optionalSkills)
      console.log('Current roleFormData mandatorySkills:', roleFormData?.mandatorySkills)
      console.log('================================')

      setJobDetailsForm(parsedJdValue) // Now you can safely access `data`
      roleFormData.jdDetails = parsedJdValue
      roleFormData.jdUrl = JSON.parse(storedJdFile)

      // Map JD skills to eligibility criteria
      const compulsorySkills = parsedJdValue?.Compulsory_Skills || []
      const secondarySkills = parsedJdValue?.Secondary_Skills || []
      const optionalSkills = parsedJdValue?.Optional_Skills || []
      
      console.log('Compulsory Skills:', compulsorySkills)
      console.log('Secondary Skills:', secondarySkills)
      console.log('Optional Skills:', optionalSkills)
            if (compulsorySkills.length > 0 || secondarySkills.length > 0) {
        console.log('Storing JD skills from new upload for later mapping...')
        
        // Store the JD skills for later processing when skills list is available
        const jdSkillsData = {
          compulsorySkills: compulsorySkills,
          secondarySkills: secondarySkills,
          optionalSkills: optionalSkills,
          timestamp: Date.now()
        }
        localStorage.setItem('pendingJdSkills', JSON.stringify(jdSkillsData))
        console.log('New JD skills stored for mapping:', jdSkillsData)
      } else {
        console.log('No compulsory or secondary skills found in JD data')
      }

      if (
        !id &&
        currentStep <= jobDetailsStepNum &&
        !roleFormData?.jobDetails?.jobRoleDocs?.length
      ) {
        roleFormData.jobDetails.jobRoleDocs = JSON.parse(storedJdFile)
      }
    } else {
      console.log('No stored value found for jdDetails in localStorage')
    }
  }, [jdData])

  useEffect(() => {
    if (
      triggerBack &&
      id &&
      ((roleFormData?.status == 1 && roleFormData?.republishedDate) ||
        roleFormData?.status != 1)
    ) {
      setQualificationError('')
      fetchRoleData({ roleId: id })
    }
  }, [triggerBack])

  useEffect(() => {
    if (currentStep === eligibilityCriteriaStepNum) {
      let getData
      getData = setTimeout(() => {
        mandatorySkillsAPI(0, skillSearch)
      }, 500)

      return () => clearTimeout(getData)
    }
  }, [skillSearch, currentStep])

  // Process pending JD skills when skills list becomes available
  useEffect(() => {
    const pendingJdSkills = localStorage.getItem('pendingJdSkills')
    
    console.log('=== SKILLS MAPPING EFFECT TRIGGERED ===')
    console.log('Pending JD skills:', pendingJdSkills)
    console.log('listOfSkills length:', listOfSkills?.length)
    console.log('listOfMandatorySkills length:', listOfMandatorySkills?.length)
    console.log('Skills manually modified flag:', skillsManuallyModified)
    
    if (pendingJdSkills && listOfSkills?.length > 0) {
      if (skillsManuallyModified) {
        console.log('=== SKILLS MANUALLY MODIFIED - SKIPPING JD SKILLS PROCESSING ===')
        console.log('Not processing pending JD skills because skills have been manually modified')
        localStorage.removeItem('pendingJdSkills') // Clear the pending skills to prevent future processing
        return
      }
      
      console.log('=== PROCESSING PENDING JD SKILLS ===') 
      const skillsData = JSON.parse(pendingJdSkills)
      console.log('Pending JD skills data:', skillsData)
      console.log('Available skills list (listOfSkills):', listOfSkills)
      
      // Function to find skill IDs from skill names
      const findSkillIds = (skillNames, skillsList) => {
        return skillNames.map(skillName => {
          const foundSkill = skillsList?.find(skill => 
            skill?.skillName?.toLowerCase() === skillName?.toLowerCase() ||
            skill?.name?.toLowerCase() === skillName?.toLowerCase() ||
            skill?.label?.toLowerCase() === skillName?.toLowerCase()
          )
          console.log(`Mapping skill "${skillName}" to ID:`, foundSkill?.id || foundSkill?.skillId || 'NOT_FOUND')
          return foundSkill?.id || foundSkill?.skillId || skillName
        }).filter(Boolean)
      }

      const compulsorySkillIds = findSkillIds(skillsData.compulsorySkills, listOfSkills)
      const secondarySkillIds = findSkillIds(skillsData.secondarySkills, listOfSkills)
      const optionalSkillIds = findSkillIds(skillsData.optionalSkills, listOfSkills)
      const allMandatorySkillIds = [...compulsorySkillIds, ...secondarySkillIds]
      
      console.log('Final mapped skill IDs:')
      console.log('- Compulsory:', compulsorySkillIds)
      console.log('- Secondary:', secondarySkillIds)
      console.log('- Optional:', optionalSkillIds)
      console.log('- All Mandatory:', allMandatorySkillIds)
      
      if (allMandatorySkillIds.length > 0) {
        // Create selectedSkills array for UI display
        const mappedSelectedSkills = []
        
        // Add compulsory skills as mandatory
        skillsData.compulsorySkills.forEach(skillName => {
          const foundSkill = listOfSkills?.find(skill => 
            skill?.skillName?.toLowerCase() === skillName?.toLowerCase() ||
            skill?.name?.toLowerCase() === skillName?.toLowerCase() ||
            skill?.label?.toLowerCase() === skillName?.toLowerCase()
          )
          if (foundSkill) {
            mappedSelectedSkills.push({
              id: foundSkill.id || foundSkill.skillId,
              skillName: foundSkill.skillName || foundSkill.name,
              isMandatory: true
            })
          }
        })
        
        // Add secondary skills as mandatory
        skillsData.secondarySkills.forEach(skillName => {
          const foundSkill = listOfSkills?.find(skill => 
            skill?.skillName?.toLowerCase() === skillName?.toLowerCase() ||
            skill?.name?.toLowerCase() === skillName?.toLowerCase() ||
            skill?.label?.toLowerCase() === skillName?.toLowerCase()
          )
          if (foundSkill) {
            mappedSelectedSkills.push({
              id: foundSkill.id || foundSkill.skillId,
              skillName: foundSkill.skillName || foundSkill.name,
              isMandatory: true
            })
          }
        })
        
        // Add optional skills as non-mandatory
        skillsData.optionalSkills.forEach(skillName => {
          const foundSkill = listOfSkills?.find(skill => 
            skill?.skillName?.toLowerCase() === skillName?.toLowerCase() ||
            skill?.name?.toLowerCase() === skillName?.toLowerCase() ||
            skill?.label?.toLowerCase() === skillName?.toLowerCase()
          )
          if (foundSkill) {
            mappedSelectedSkills.push({
              id: foundSkill.id || foundSkill.skillId,
              skillName: foundSkill.skillName || foundSkill.name,
              isMandatory: false
            })
          }
        })
        
        console.log('Mapped selected skills for UI:', mappedSelectedSkills)
        
        // Update selectedSkills state for UI display
        setSelectedSkills(mappedSelectedSkills)
        
        // Update mandatorySkillsIds for the mandatory skills
        const mandatoryIds = mappedSelectedSkills
          .filter(skill => skill.isMandatory)
          .map(skill => skill.id)
        setMandatorySkillsIds(mandatoryIds)
        console.log('Updated mandatorySkillsIds:', mandatoryIds)
        
        // Update skills in roleFormData
        setRoleFormData(prev => {
          const updated = {
            ...prev,
            mandatorySkills: {
              ...prev.mandatorySkills,
              primary: {
                type: prev.mandatorySkills?.primary?.type || 'AND',
                skills: compulsorySkillIds
              },
              mandatory: allMandatorySkillIds,
              mandatoryCount: allMandatorySkillIds.length
            },
            optionalSkills: optionalSkillIds
          }
          console.log('Updated roleFormData with mapped skills:', updated.mandatorySkills)
          return updated
        })
        
        // Also update form fields
        setTimeout(() => {
          console.log('Setting form fields with mapped skill IDs...')
          roleForm.setFieldsValue({
            mandatorySkills: {
              primary: {
                type: 'AND',
                skills: compulsorySkillIds
              },
              mandatory: allMandatorySkillIds,
              mandatoryCount: allMandatorySkillIds.length
            },
            optionalSkills: optionalSkillIds
          })
          console.log('Form fields updated successfully!')
          
          // Clear the pending skills after successful mapping
          localStorage.removeItem('pendingJdSkills')
          console.log('Pending JD skills processed and cleared')
        }, 100)
      } else {
        console.log('No valid skill IDs found, keeping pending skills for retry')
      }
      
      console.log('=====================================') 
    } else {
      console.log('Conditions not met for processing JD skills')
      console.log('- Has pending skills:', !!pendingJdSkills)
      console.log('- Skills list available:', listOfSkills?.length > 0)
    }
  }, [listOfSkills, roleForm, skillsManuallyModified])

  const handleSubmitChange = value => {
    setSaveCorporate(true)
  }

  useEffect(() => {
    if (load) {
      if (load == 'Success') {
        const nextStep = currentStep + 1
        setCurrentStep(nextStep)
        setSave(false)
      } else {
        setSave(false)
      }
    }
    const csValue = searchParams.get('CS')
    if (csValue) {
      setCurrentStep(Number(csValue))
    }
  }, [])

  useEffect(() => {
    if (id && !deleteRole) {
      window.history.replaceState(
        null,
        '',
        `/jobRoles/editRole/${id}?CS=${currentStep}`
      )
    } else {
      window.history.replaceState(
        null,
        '',
        `/jobRoles/newRole?CS=${currentStep}`
      )
      setDeleteRole(false)
    }

    searchParams.set('CS', currentStep)
  }, [currentStep])

  const onAddNewRole = async roleData => {
    if (!lengthError) {
      setLoading(true)
      const response = await addNewRole(instituteCampusId, roleData, setLoad)
      setSave(false)
      if (response?.message == 'Success') {
        window.scrollTo({ top: 0, behavior: 'smooth' })
        const nextStep = Number(currentStep) + 1
        setCurrentStep(nextStep)
        setStepIcon(false)
        setSave(false)
        if (response?.data?.id) {
          setId(response?.data?.id)
          if (draft) {
            setConfirmLoading(true)
            setTimeout(() => {
              setConfirmLoading(false)
              navigate('/jobRoles')
            }, 2000)
            localStorage.removeItem('jdDetails')
            localStorage.removeItem('jdFile')
          } else {
            window.history.replaceState(
              null,
              '',
              `/jobRoles/editRole/${response?.data?.id}?CS=${currentStep}`
            )
            fetchRoleData({ roleId: response?.data?.id })
            const res = await getJobRolePreview(response?.data?.id)
            setPreviewData(res.data.data)
          }
        }
      }

      setLoading(false)
      return response
    }
  }
  const countTrueValues = obj => {
    return Object.values(obj).filter(value => value === true).length
  }
  const lengthOfTrueData = countTrueValues(stepStatus)
  const [hasNotChange, setHasNotChange] = useState(false)
  const [isEdited, setIsEdited] = useState(false)

  let hasNotChanged = false
  const updateNewRoles = async (
    payload,
    setLoad,
    id,
    error,
    step,
    type,
    score,
    action,
    stepToGo
  ) => {
    if (
      (qualificationError != '' ||
        type ||
        (!error && step == eligibilityCriteriaStepNum) ||
        (score != '' && step == eligibilityCriteriaStepNum) ||
        (lengthError && step == jobDetailsStepNum)) &&
      !draft
    ) {
      //console.log('... negative case')
    } else {
      const roleData = hasChanged(editData)
      const eligibilityCriteria = editData?.dbEligibilityCriteria
      const eligibilityDataConversion =
        convertEligibilityData(eligibilityCriteria)
      const eligibilityPayload = convertEligibilityData(
        payload?.elgibilty?.eligibilityCriteria
      )
      const scoreInRole = {
        avg: editData?.avgScore ?? '0',
        ug: editData?.UGScore ?? '0',
        pg: editData?.PGScore ?? '0',
        tenth: editData?.tenthScore ?? '0',
        twelfth: editData?.twelfthScore ?? '0',
        diploma: editData?.UGDiplomaScore ?? '0',
      }
      const scoreInPayload = {
        avg: payload?.elgibilty?.scores?.avg?.toString() ?? '0',
        ug: payload?.elgibilty?.scores?.UG?.toString() ?? '0',
        pg: payload?.elgibilty?.scores?.PG?.toString() ?? '0',
        tenth: payload?.elgibilty?.scores?.tenth?.toString() ?? '0',
        twelfth: payload?.elgibilty?.scores?.twelfth?.toString() ?? '0',
        diploma: payload?.elgibilty?.scores?.UGDiploma?.toString() ?? '0',
      }
      let roleFinalDataToStringify = {
        ...roleData,
        elgibilty: {
          ...roleData?.elgibilty,
          eligibilityCriteria: eligibilityDataConversion,
          scores: scoreInRole,
        },
      }
      let editedPayload = {
        ...payload,
        elgibilty: {
          ...payload?.elgibilty,
          eligibilityCriteria: eligibilityPayload,
          scores: scoreInPayload,
        },
      }

      hasNotChanged =
        JSON.stringify(roleFinalDataToStringify) ===
        JSON.stringify(editedPayload)

      // Also check if skills have changed (not captured by hasChanged comparison)
      if (hasNotChanged) {
        const currentSkillIds = selectedSkills
          ?.map(s => s?.skillId || s?.id)
          ?.filter(Boolean)
          ?.sort()
        const initialSkillIds = editData?.jobRoleSkills
          ?.map(s => s?.skillId || s?.id)
          ?.filter(Boolean)
          ?.sort()
        if (JSON.stringify(currentSkillIds || []) !== JSON.stringify(initialSkillIds || [])) {
          hasNotChanged = false
        }
      }

      // Also check if document upload has changed
      if (hasNotChanged) {
        const currentDocs = payload?.jobDetails?.jobRoleDocs
          ?.filter(item => item?.fileName && item?.fileUrl)
          ?.map(item => item.fileUrl)
          ?.sort()
        const initialDocs = editData?.jobRoleDocs
          ?.filter(item => item?.fileName && item?.fileUrl)
          ?.map(item => item.fileUrl)
          ?.sort()
        if (JSON.stringify(currentDocs || []) !== JSON.stringify(initialDocs || [])) {
          hasNotChanged = false
        }
      }

      setHasNotChange(hasNotChanged)

      if (
        !hasNotChanged ||
        (editData?.isEdited && currentStep >= eligibilityCriteriaStepNum)
      ) {
        setPublishButtonDisable(false)
      } else {
        setPublishButtonDisable(true)
      }

      setLoading(true)
      let updatedPayload
      if (currentStep >= previewStepNum && !draft) {
        if (jdFile?.length) {
          const data = {
            fileName: jdFile[0]?.name,
            fileType: jdFile[0]?.type,
            fileUrl: jdFile[0]?.url,
            fileSize: jdFile[0]?.size,
          }
          
          console.log('=== JD FILE ADDITION DEBUG ===');
          console.log('JD file data to add:', data);
          console.log('Current docs array:', payload?.jobDetails?.jobRoleDocs);
          
          const docs = payload?.jobDetails?.jobRoleDocs || []

          // Check if this file already exists and has valid data
          const fileExists = docs.some(doc => doc?.fileUrl === data?.fileUrl)
          const hasValidData = data.fileName && data.fileUrl && data.fileName.trim() !== '' && data.fileUrl.trim() !== ''
          
          console.log('File exists:', fileExists, 'Has valid data:', hasValidData);
          
          if (!fileExists && hasValidData) {
            docs.push(data)
            payload.jobDetails.jobRoleDocs = docs
            console.log('Added JD file to docs. New docs array:', docs);
          }
        }
        updatedPayload = {
          ...payload,
          currentState: Number(currentStep) + 1,
          status: 1,
          republishedDate: payload?.republishedDate,
          isEdited: !hasNotChanged,
        }
      } else if (currentStep == eligibilityCriteriaStepNum && draft) {
        let mandatorySkills = payload.elgibilty.mandatorySkills
        // mandatorySkills.mandatory = mandatorySkills.mandatory?.map(item => {
        //   return {
        //     ...item,
        //     skillId: item?.id,
        //   }
        // })
        if (mandatorySkills && (mandatorySkills.mandatory || mandatorySkills.mandatory === null)) {
          mandatorySkills = {
            ...mandatorySkills,
            mandatory: mandatorySkills.mandatory?.map(item => ({
              ...item,
              skillId: item?.id,
            })) || []
          };
        }
        updatedPayload = {
          ...payload,
          mandatorySkills,
          isEdited: true,
        }
      } else {
        updatedPayload = {
          ...payload,
          currentState: lengthOfTrueData,
          isEdited: !hasNotChanged || editData?.isEdited,
        }
      }

      if (
        !hasNotChanged ||
        currentStep >= eligibilityCriteriaStepNum ||
        draft
      ) {
        if (
          updatedPayload?.status === 1 &&
          updatedPayload?.elgibilty?.eligibilityCriteria?.length === 0
        ) {
          //console.log('Added fix')
          //ErrorMessage('Please add eligibility criteria')
        } else {
          if (payload?.forRevert && candidateMetrics?.inEligibleList?.length) {
            revertInEligibleStudent(id, {
              instituteCampusId: instituteCampusId,
              inEligibleList: candidateMetrics?.inEligibleList || [],
            })
          }

          const updateResponse = await updateNewRole(
            instituteCampusId,
            updatedPayload,
            setLoad,
            id,
            setButtonLoading
          )
          setSave(false)
          if (updateResponse?.message == 'Success') {
            window.scrollTo({ top: 0, behavior: 'smooth' })
            const nextStep = stepToGo || Number(currentStep) + 1
            setSave(false)
            const response = await getJobRolePreview(id)
            setJobRolePreviewData(response?.data?.data)
            setPreviewData(response?.data?.data)
            if (response?.data?.data?.id) {
              setId(response?.data?.data?.id)

              if (draft) {
                setConfirmLoading(true)
                setTimeout(() => {
                  setConfirmLoading(false)
                  navigate('/jobRoles')
                }, 2000)
                localStorage.removeItem('jdDetails')
                localStorage.removeItem('jdFile')
              } else if (
                isReturnBoolean(
                  roleFormData?.roleStatus,
                  response?.data?.data?.status,
                  roleFormData?.republishedDate
                )
              ) {
                if (isEditModal?.open) {
                  setTimeout(() => {
                    navigate('/jobRoles')
                    setIsEditModal(prevState => ({
                      ...prevState,
                      open: false,
                      loading: false,
                    }))
                  }, 2000)
                } else {
                  setCurrentStep(nextStep)
                }
              } else if (Number(currentStep) >= previewStepNum && !action) {
                showModal()
              }
              // commanded and tested working fine need to confirm its needed or not
              // else {
              //   window.history.replaceState(
              //     null,
              //     '',
              //     `/jobRoles/editRole/${response?.data?.data?.id}?CS=${currentStep}`
              //   )
              //   fetchRoleData({ roleId: response?.data?.data?.id })
              //   const res = await getJobRolePreview(response?.data?.data?.id)
              //   setPreviewData(res.data.data)
              // }
            }
          } else {
            if (
              payload?.forRevert &&
              candidateMetrics?.inEligibleList?.length
            ) {
              revertInEligibleStudent(id, {
                instituteCampusId: instituteCampusId,
                inEligibleList: candidateMetrics?.inEligibleList || [],
              })
            }
            const updateResponse = await updateNewRole(
              instituteCampusId,
              updatedPayload,
              setLoad,
              id,
              setButtonLoading
            )
            setSave(false)

            if (updateResponse?.message == 'Success') {
              window.scrollTo({ top: 0, behavior: 'smooth' })
              const nextStep = stepToGo || Number(currentStep) + 1
              setSave(false)
              const response = await getJobRolePreview(id)
              setJobRolePreviewData(response?.data?.data)
              setPreviewData(response?.data?.data)
              if (response?.data?.data?.id) {
                setId(response?.data?.data?.id)

                if (draft) {
                  setConfirmLoading(true)
                  setTimeout(() => {
                    setConfirmLoading(false)
                    navigate('/jobRoles')
                  }, 2000)
                  localStorage.removeItem('jdDetails')
                  localStorage.removeItem('jdFile')
                } else if (
                  isReturnBoolean(
                    roleFormData?.roleStatus,
                    undefined,
                    roleFormData?.republishedDate
                  )
                ) {
                  if (isEditModal?.open) {
                    setTimeout(() => {
                      navigate('/jobRoles')
                      setIsEditModal(prevState => ({
                        ...prevState,
                        open: false,
                        loading: false,
                      }))
                    }, 2000)
                  } else {
                    setCurrentStep(nextStep)
                  }
                } else if (Number(currentStep) >= previewStepNum && !action) {
                  showModal()
                } else {
                  if (!action) {
                    setCurrentStep(nextStep)
                  } else {
                    setCurrentStep(stepToGo)
                  }
                  if (currentStep == autoJDFillStepNum) {
                    window.history.replaceState(
                      null,
                      '',
                      `/jobRoles/newRole?CS=${currentStep + 1}`
                    )
                  } else {
                    window.history.replaceState(
                      null,
                      '',
                      `/jobRoles/editRole/${response?.data?.data?.id}?CS=${
                        currentStep + 1
                      }`
                    )
                  }
                  fetchRoleData({ roleId: response?.data?.data?.id })
                }
              }
            } else {
              const updateResponse = await updateNewRole(
                instituteCampusId,
                updatedPayload,
                setLoad,
                id,
                setButtonLoading
              )
              setSave(false)

              if (updateResponse?.message == 'Success') {
                window.scrollTo({ top: 0, behavior: 'smooth' })
                const nextStep = stepToGo || Number(currentStep) + 1
                setSave(false)
                const response = await getJobRolePreview(id)
                setJobRolePreviewData(response?.data?.data)
                setPreviewData(response?.data?.data)
                if (response?.data?.data?.id) {
                  setId(response?.data?.data?.id)

                  if (draft) {
                    setConfirmLoading(true)
                    setTimeout(() => {
                      setConfirmLoading(false)
                      navigate('/jobRoles')
                    }, 2000)
                    localStorage.removeItem('jdDetails')
                    localStorage.removeItem('jdFile')
                  } else if (isReturnBoolean(roleFormData?.roleStatus)) {
                    if (isEditModal?.open) {
                      setTimeout(() => {
                        navigate('/jobRoles')
                        setIsEditModal(prevState => ({
                          ...prevState,
                          open: false,
                          loading: false,
                        }))
                      }, 2000)
                    } else {
                      setCurrentStep(nextStep)
                    }
                  } else if (Number(currentStep) >= previewStepNum && !action) {
                    showModal()
                  } else {
                    if (!action) {
                      setCurrentStep(nextStep)
                    } else {
                      setCurrentStep(stepToGo)
                    }
                    if (currentStep == autoJDFillStepNum) {
                      window.history.replaceState(
                        null,
                        '',
                        `/jobRoles/newRole?CS=${currentStep + 1}`
                      )
                    } else {
                      window.history.replaceState(
                        null,
                        '',
                        `/jobRoles/editRole/${response?.data?.data?.id}?CS=${
                          currentStep + 1
                        }`
                      )
                    }
                    fetchRoleData({ roleId: response?.data?.data?.id })
                  }
                }
              } else {
                setTimeout(() => {
                  setIsEditModal(prevState => ({
                    ...prevState,
                    open: false,
                    loading: false,
                  }))
                }, 1000)
              }
              return updateResponse
            }
            return updateResponse
          }
        }
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' })
        const nextStep = Number(currentStep) + 1
        setSave(false)
        if (!action) {
          setCurrentStep(nextStep)
        }

        if (action && hasNotChanged) {
          setCurrentStep(stepToGo)
        }
      }

      setLoading(false)
    }
  }
  const handleDraftChange = () => {
    setQualificationError('')
    setDraft(true)
    setSave(true)
    setMandatoryTypeError(false)
    setQualificationError(false)
    setPublishCheck(false)
  }
  const showModal = () => {
    setOpen(true)
  }

  const handleCancel = () => {
    setButtonLoading(false)
    setOpen(false)
    handleTableNavigation()
  }
  const handleTableNavigation = () => {
    navigate('/jobRoles')
    localStorage.removeItem('jdDetails')
    localStorage.removeItem('jdFile')
  }

  const handleNextChange = async () => {
    setSkillSearch('')
    try {
      // if (isReturnBoolean(roleFormData?.roleStatus,undefined,roleFormData?.republishedDate)) {
      //   const result = await checkApplicationDate()
      //   if (result) {
      //     finalizeAction()
      //   }
      // } else {
      if (buttonLoading === false) {
        setButtonLoading(true)

        // Handle step-specific logic
        if (currentStep === autoJDFillStepNum) {
          setParseLoading(true)
        } else if (currentStep >= previewStepNum) {
          setShowRoleDrawer(true)
          setPublishCheck(true)
        }

        finalizeAction()
        // }
      }
    } catch (error) {
      console.error('Error in handleNextChange:', error)
    }
  }

  // Abstracted function to avoid repetition
  const finalizeAction = () => {
    setSave(true)
    setDraft(false)
    if (currentStep !== 3) {
      handleButtonLoading()
    }
    setButtonLoading(false)
  }

  const handleButtonLoading = () => {
    setTimeout(() => {
      setButtonLoading(false)
    }, [2000])
  }

  const fetchTypes = async () => {
    const response = await getEligibilityCriteria({
      searchValue: '',
      searchType: 'ALL',
      searchField: [],
    })
    if (Array.isArray(response)) {
      const typesArray = [...new Set(response.map(item => item.type))]

      const customOrder = [
        'UG',
        'PG',
        'DIPLOMA',
        'P.G.DIPLOMA',
        'P_G_DIPLOMA',
        'PHD',
      ]

      const normalizedTypes = typesArray.map(type =>
        ['P.G.DIPLOMA', 'P_G_DIPLOMA'].includes(type) ? 'DIPLOMA' : type
      )

      const uniqueTypes = [...new Set(normalizedTypes)]

      const sortedQualifications = uniqueTypes
        .filter(type => customOrder.includes(type)) // Keep only valid types
        .sort((a, b) => customOrder.indexOf(a) - customOrder.indexOf(b))

      setCriteriaTypes(sortedQualifications)
    }
  }

  useEffect(() => {
    fetchTypes()
  }, [])

  return (
    <Wrapper>
      <Header
        confirmLoading={confirmLoading}
        publishButtonDisable={
          (() => {
            // If editing an existing role (editData?.id exists), always enable publish button
            if (editData?.id) {
              return false;
            }
            
            // For new roles, keep the original validation logic
            const isReturnBooleanResult = isReturnBoolean(
              roleFormData?.roleStatus,
              undefined,
              roleFormData?.republishedDate,
              isEdited
            );
            const stepValidationRequired = lengthOfTrueData !== 4;
            
            return isReturnBooleanResult || stepValidationRequired;
          })()
        }
        status={editData?.status ? Number(editData.status) : 0}
        addNewRole={addNewRole}
        handleDraftChange={handleDraftChange}
        setSave={setSave}
        setTriggerBack={setTriggerBack}
        setSaveCorporate={setSaveCorporate}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        handleAddNewCompany={handleAddNewCompany}
        isCompanyContext={addCompanyDrawer}
        handleSubmitChange={handleSubmitChange}
        id={id}
        setShowRoleDrawer={setShowRoleDrawer}
        handleTableNavigation={handleTableNavigation}
        headingText={id ? 'Edit Role ' : 'Add New Role'}
        setPublishCheck={setPublishCheck}
        loading={loading}
        setQualificationError={setQualificationError}
        setDraft={setDraft}
        setParseLoading={setParseLoading}
        params={params}
        jdFile={jdFile}
        handleNextChange={handleNextChange}
        buttonLoading={buttonLoading}
        setSkillSearch={setSkillSearch}
      />
      <MainWrapper column>
        {!addCompanyDrawer ? (
          <RolesForm
            mandatorySkillsIds={mandatorySkillsIds}
            setMandatorySkillsIds={setMandatorySkillsIds}
            selectedSkills={selectedSkills}
            setSelectedSkills={setSelectedSkills}
            skillsManuallyModified={skillsManuallyModified}
            setSkillsManuallyModified={setSkillsManuallyModified}
            candidateMetrics={candidateMetrics}
            setCandidateMetrics={setCandidateMetrics}
            setOpen={setOpen}
            confirmLoading={confirmLoading}
            setPreviewData={setPreviewData}
            previewData={previewData}
            hasNotChanged={hasNotChanged}
            hasNoteChanged={hasNotChange}
            setStep={setStep}
            setStepStatus={setStepStatus}
            stepStatus={stepStatus}
            step={step}
            setIsEdit={setIsEdit}
            isEdit={isEdit}
            lengthError={lengthError}
            setLengthError={setLengthError}
            setQualificationError={setQualificationError}
            qualificationError={qualificationError}
            labelName={labelName}
            setLabelName={setLabelName}
            setSelectedType={setSelectedType}
            selectedType={selectedType}
            getDegreeData={getDegreeData}
            degreeList={degreeList}
            roleForm={roleForm}
            id={params?.roleId || id}
            setId={setId}
            setKey={setKey}
            key={key}
            setStepIcon={setStepIcon}
            stepIcon={stepIcon}
            save={save}
            setSave={setSave}
            saveCorporate={saveCorporate}
            currentStep={currentStep}
            checkAllCompleted={checkAllCompleted}
            setCurrentStep={setCurrentStep}
            handleAddNewCompany={handleAddNewCompany}
            getListOfCompanies={getListOfCompanies}
            getMasterSearchApi={getMasterSearchApi}
            getRolesListData={getRolesListData}
            setRoleFormData={setRoleFormData}
            roleFormData={roleFormData}
            rolesList={rolesList}
            companyList={companyList}
            addNewRole={addNewRole}
            setLoad={setLoad}
            load={load}
            onAddNewRole={onAddNewRole}
            getListOfCities={getListOfCities}
            updateNewRole={updateNewRoles}
            getSpecialisationList={getSpecialisationList}
            specialisationList={specialisationList}
            setSkillSearch={setSkillSearch}
            degreeListData={degreeListData}
            setDegreeListData={setDegreeListData}
            listOfMandatorySkills={listOfMandatorySkills}
            skillCount={mandatorySkillCount}
            listOfOptionalSkills={listOfMandatorySkills}
            setListOfMandatorySkills={setListOfMandatorySkills}
            setListOfSkills={setListOfSkills}
            listOfSkills={listOfSkills}
            getCandidateMetrics={getCandidateMetrics}
            getRoleDetails={getRoleDetails}
            roleId={params?.roleId}
            roleData={roleData}
            initialLoading={loading}
            setInitialLoading={setLoading}
            jobRolePreviewData={jobRolePreviewData}
            editData={editData}
            getJobRolePreview={getJobRolePreview}
            getEligibilityCriteriaQualification={
              getEligibilityCriteriaQualification
            }
            setScoreType={setScoreType}
            scoreType={scoreType}
            setMandatoryTypeError={setMandatoryTypeError}
            mandatoryTypeError={mandatoryTypeError}
            setShowRoleDrawer={setShowRoleDrawer}
            showRoleDrawer={showRoleDrawer}
            publishCheck={publishCheck}
            draft={draft}
            setPublishCheck={setPublishCheck}
            setDraft={setDraft}
            publishButtonDisable={publishButtonDisable}
            jobDetailsForm={jobDetailsForm}
            jdFile={jdFile}
            setJdFile={setJdFile}
            setParseLoading={setParseLoading}
            parseLoading={parseLoading}
            getJdDetails={getJdDetails}
            setJdData={setJdData}
            jdData={jdData}
            params={params}
            searchCities={searchCities}
            setDeleteRole={setDeleteRole}
            deleteRole={deleteRole}
            deleteJobRole={deleteJobRole}
            defaultRoleFormData={defaultRoleFormData}
            handleNextChange={handleNextChange}
            instituteCampusId={instituteCampusId}
            triggerBack={triggerBack}
            setTriggerBack={setTriggerBack}
            setJobDetailsForm={setJobDetailsForm}
            getEligibilityCriteria={getEligibilityCriteria}
            initialResponse={initialResponse}
            setIsEditModal={setIsEditModal}
            isEditModal={isEditModal}
            criteriaTypes={criteriaTypes}
            skillSearch={skillSearch}
            fetchRoleData={fetchRoleData}
            setButtonLoading={setButtonLoading}
            handleButtonChanges={handleButtonChanges}
            getCities={getCities}
            sendNotificationBulkEmail={sendNotificationBulkEmail}
            getInEligibleCandidates={getInEligibleCandidates}
            setHasNotChange={setHasNotChange}
            setIsEdited={setIsEdited}
            isEdited={isEdited}
            setConfirmLoading={setConfirmLoading}
          />
        ) : (
          <CompanyDetails
            saveCorporate={saveCorporate}
            setSaveCorporate={setSaveCorporate}
            handleAddNewCompany={handleAddNewCompany}
            getListOfCountries={getListOfCountries}
            countryList={countryList}
            getListOfStates={getListOfStates}
            getListOfCities={getListOfCities}
            addNewCompany={addNewCompany}
            getListOfCompanies={getListOfCompanies}
          />
        )}
      </MainWrapper>
      <Modals
        title=""
        closable={false}
        width={'550px'}
        height="250px"
        style={{ height: '250px', borderRadius: '15px' }}
        open={open}
        footer={false}
      >
        <div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <SubmitCloseIcon />
          </div>
          <div>
            <p
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '1.5em',
                fontWeight: 600,
              }}
            >
              {modalText}
            </p>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button.Secondary
              text="Close"
              onClick={handleCancel}
              width="100px"
            />
          </div>
        </div>
      </Modals>
    </Wrapper>
  )
}

export default NewJobRole